import React, { Component } from 'react';

import api from 'core/utils/api';
import Spin from 'components/ui/Spin';
import ExpiringDeviceList from './ExpiringDeviceList';

class ExpiringDevicesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    api.get('/devices', { params: { expiring: true, is_testable: false } })
      .then((res) => {
        const { devices } = res.data;
        this.setState({
          devices,
          loading: false,
        });
      });
  }

  render() {
    const { loading, devices } = this.state;

    if (loading) {
      return <Spin />;
    }

    return (
      <ExpiringDeviceList devices={devices} />
    );
  }
}

export default ExpiringDevicesContainer;



// WEBPACK FOOTER //
// ./src/features/dashboard/ExpiringDevicesContainer.js